import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "@src/locales/en.json";
import de from "@src/locales/de.json";

/**
 * When loaded as a federated remote, the shell has already initialized i18next.
 * Calling init() again would replace all resources, wiping other modules' translations.
 * We only init when running standalone (local dev); otherwise just merge our bundles.
 */
if (!i18n.isInitialized) {
  i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      resources: {
        en: { translation: en },
        de: { translation: de },
      },
      fallbackLng: "en",
      interpolation: { escapeValue: false },
      react: { useSuspense: true },
    });
} else {
  i18n.addResourceBundle("en", "translation", en, true, true);
  i18n.addResourceBundle("de", "translation", de, true, true);
}

export default i18n;
